<template>
  <div
    v-if="isBusy"
    class="row">
    <!-- Busy -->
    <div
      class="col text-center">
      <coozzy-spinner />
    </div>
  </div>
  <section
    v-else
    data-cy="application-form-company-section">
    <application-form-company-basic
      ref="basic"
      :company="company"
      :sending="sending" />
    <hr>
    <application-form-company-contact-person
      ref="contactPerson"
      :company="company"
      :sending="sending" />
    <hr v-if="object && object.category !== 'PARKING_SPACE' && object.category !== 'SECONDARY_ROOM'">
    <application-form-tenancy
      v-if="object && object.category !== 'PARKING_SPACE' && object.category !== 'SECONDARY_ROOM'"
      ref="tenancy"
      :company="company"
      :sending="sending"
      :object="object" />
  </section>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue'
import ApplicationFormCompanyBasic from '@/marketingBasic/components/applicationForm/ApplicationFormCompanyBasic.vue'
import ApplicationFormCompanyContactPerson from '@/marketingBasic/components/applicationForm/ApplicationFormCompanyContactPerson.vue'
import ApplicationFormTenancy from '@/marketingBasic/components/applicationForm/ApplicationFormTenancy.vue'
import CoozzySpinner from '@/framework/components/misc/CoozzySpinner.vue'
import { ApplicationFormCompany, ObjectWithCategory } from '@/types/models'

type CompanyBasicRef = { isInvalid: () => boolean }
type CompanyContactRef = { isInvalid: () => boolean }

export default Vue.extend({
  name: 'ApplicationFormCompany',
  components: {
    ApplicationFormTenancy,
    ApplicationFormCompanyBasic,
    ApplicationFormCompanyContactPerson,
    CoozzySpinner
  },
  props: {
    company: {
      type: Object as PropType<ApplicationFormCompany | null>,
      default: null
    },
    sending: {
      type: Boolean,
      default: false
    },
    isBusy: {
      type: Boolean,
      default: false
    },
    object: {
      type: Object as PropType<ObjectWithCategory | null>,
      default: null
    }
  },
  methods: {
    isInvalid() {
      let allSubformsValid = true
      const basic = this.$refs.basic as CompanyBasicRef | undefined
      const contactPerson = this.$refs.contactPerson as CompanyContactRef | undefined
      if (basic?.isInvalid()) {
        allSubformsValid = false
      }
      if (contactPerson?.isInvalid()) {
        allSubformsValid = false
      }
      return !allSubformsValid
    }
  }
})
</script>

<style lang="scss" scoped>
</style>
